import ComponentMapping from "@alboom/custom-page-components";

const propsReducer = (props) => {
  return props.reduce((curr, prop) => {
    if (prop.group) {
      const groupProps = propsReducer(prop.props);
      return {
        ...curr,
        ...groupProps,
      };
    }
    // Here in some cases we need to check from where to get our default
    // props, so for some custom elements, custom logic is needed.
    switch (prop.element) {
      // If our element is RangeSlide, we need to retrieve the default value
      // from the default option of the slider.
      case "RangeSlide": {
        const defaultType =
          prop.options.filter((item) => item.type === prop.defaultType)[0] ||
          prop.options[0];

        const props = {
          [prop.name]: defaultType.defaultValue,
          [`${prop.name}Type`]: defaultType.type,
        };

        return {
          ...curr,
          ...props,
        };
      }
      default:
        return {
          ...curr,
          [prop.name]: prop.defaultValue,
        };
    }
  }, {});
};

const getComponentData = (elementName, version = "default") => {
  const target = ComponentMapping[elementName][version];
  const { component, manifest } = target;
  const manifestProps = propsReducer(manifest.props);
  const props = { ...component.defaultProps, ...manifestProps };
  return props;
};

export const getComponentDefinition = (elementName, version = "default") => {
  const target = ComponentMapping[elementName][version];
  return target.manifest;
};

export default getComponentData;
